/**
 * @fileoverview 404 Not Found page component
 * @module shared/pages/NotFoundPage
 */

import { ReactElement } from 'react'
import { Link } from 'react-router-dom'
import { Button } from '@/shared/components/ui/Button'

/**
 * 404 Not Found page component
 *
 * @component
 * @example
 * ```tsx
 * <NotFoundPage />
 * ```
 */
export function NotFoundPage(): ReactElement {
  return (
    <div className="min-h-screen bg-background flex items-center justify-center">
      <div className="text-center space-y-6">
        <h1 className="text-6xl font-bold text-foreground">404</h1>
        <h2 className="text-2xl font-semibold text-foreground">Page Not Found</h2>
        <p className="text-muted-foreground max-w-md">
          The page you are looking for doesn't exist or has been moved.
        </p>
        <Link to="/dashboard">
          <Button variant="default">Go to Dashboard</Button>
        </Link>
      </div>
    </div>
  )
}
